import axios from 'axios';

const API_KEY = process.env.REACT_APP_TMDB_API_KEY || 'c8dea14dc917687ac631a52620e4f7ad';
const BASE_URL = 'https://api.themoviedb.org/3';

export const IMG_BASE = 'https://image.tmdb.org/t/p/original';
export const IMG_W500 = 'https://image.tmdb.org/t/p/w500';

const tmdb = axios.create({ baseURL: BASE_URL });

// Prefer newer content: released within the last ~2 years, with real audience votes.
// The date auto-rolls forward so rows always feel fresh without redeploying.
const _twoYearsAgo = () => {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 2);
  return d.toISOString().slice(0, 10);
};
const _today = () => new Date().toISOString().slice(0, 10);
const RECENT_MOVIE = `&primary_release_date.gte=${_twoYearsAgo()}&primary_release_date.lte=${_today()}&sort_by=popularity.desc&vote_count.gte=50`;
const RECENT_TV = `&first_air_date.gte=${_twoYearsAgo()}&first_air_date.lte=${_today()}&sort_by=popularity.desc&vote_count.gte=20`;
const RECENT_KIDS = `&primary_release_date.gte=${_twoYearsAgo()}&sort_by=popularity.desc&vote_count.gte=10`;

export const endpoints = {
  trending: `/trending/all/week?api_key=${API_KEY}&language=en-US`,
  netflixOriginals: `/discover/tv?api_key=${API_KEY}&with_networks=213&language=en-US${RECENT_TV}`,
  topRated: `/discover/movie?api_key=${API_KEY}&language=en-US&sort_by=vote_average.desc&vote_count.gte=500&primary_release_date.gte=${_twoYearsAgo()}`,
  actionMovies: `/discover/movie?api_key=${API_KEY}&with_genres=28&language=en-US${RECENT_MOVIE}`,
  comedyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=35&language=en-US${RECENT_MOVIE}`,
  horrorMovies: `/discover/movie?api_key=${API_KEY}&with_genres=27&language=en-US${RECENT_MOVIE}`,
  romanceMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10749&language=en-US${RECENT_MOVIE}`,
  documentaries: `/discover/movie?api_key=${API_KEY}&with_genres=99&language=en-US${RECENT_MOVIE}`,
  scifiMovies: `/discover/movie?api_key=${API_KEY}&with_genres=878&language=en-US${RECENT_MOVIE}`,
  animationMovies: `/discover/movie?api_key=${API_KEY}&with_genres=16&language=en-US${RECENT_KIDS}`,
  popularMovies: `/discover/movie?api_key=${API_KEY}&language=en-US${RECENT_MOVIE}`,
  popularTv: `/discover/tv?api_key=${API_KEY}&language=en-US${RECENT_TV}`,
  familyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10751&language=en-US&certification_country=US&certification.lte=PG${RECENT_KIDS}`,
  kidsFamily: `/discover/movie?api_key=${API_KEY}&with_genres=10751,16&language=en-US&certification_country=US&certification.lte=PG${RECENT_KIDS}`,
  kidsShows: `/discover/tv?api_key=${API_KEY}&with_genres=10762&language=en-US${RECENT_KIDS.replace('primary_release_date', 'first_air_date')}`,
};

export const fetchFrom = async (path) => {
  const { data } = await tmdb.get(path);
  return data.results || [];
};

export const searchMulti = async (query) => {
  if (!query || !query.trim()) return [];
  const { data } = await tmdb.get(
    `/search/multi?api_key=${API_KEY}&language=en-US&query=${encodeURIComponent(query.trim())}&include_adult=false`
  );
  return (data.results || []).filter(
    (r) => r.media_type !== 'person' && (r.backdrop_path || r.poster_path)
  );
};

const mediaType = (item) => item.media_type === 'tv' || item.first_air_date ? 'tv' : 'movie';

export const fetchVideos = async (item) => {
  const type = mediaType(item);
  try {
    const { data } = await tmdb.get(`/${type}/${item.id}/videos?api_key=${API_KEY}`);
    const yt = (data.results || []).find(
      (v) => v.site === 'YouTube' && (v.type === 'Trailer' || v.type === 'Teaser')
    );
    return yt ? yt.key : ((data.results || [])[0]?.key || null);
  } catch (e) {
    return null;
  }
};

export const fetchDetails = async (item) => {
  const type = mediaType(item);
  try {
    const { data } = await tmdb.get(`/${type}/${item.id}?api_key=${API_KEY}&language=en-US`);
    return data;
  } catch (e) {
    return null;
  }
};

export const getMediaType = mediaType;
